module.exports = __webpack_public_path__ + "static/media/License.06e81089.txt";